import { render, staticRenderFns } from "./ServiceStatistic.vue?vue&type=template&id=3f55f9ba&scoped=true"
import script from "./ServiceStatistic.vue?vue&type=script&lang=js"
export * from "./ServiceStatistic.vue?vue&type=script&lang=js"
import style0 from "./ServiceStatistic.vue?vue&type=style&index=0&id=3f55f9ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f55f9ba",
  null
  
)

export default component.exports